import React from 'react';
import { useDashboardFeatureFlags } from '@components';
import { Subsection, Upload, useMediaQueryContext } from '@fourthwall/components';
import { UploadIcon } from '@fourthwall/icons';
import { RemovableUpload, UploadedImage } from '../../../../components';
import { useSingleSeriesContext } from '../../hooks/useSingleSeriesContext';
import { FormFields } from '../../providers/SingleSeriesProvider/types';
import * as S from './styled';
export const ThumbnailFields = () => {
    const media = useMediaQueryContext();
    const { form, handleUploadThumbnailImage, isThumbnailImageUploading } = useSingleSeriesContext();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    if (!dashboardFeatureFlags.membershipsVideoSeriesList.enabled)
        return null;
    const handleFileDrop = async (files) => {
        if (!files?.[0])
            return;
        await handleUploadThumbnailImage(files[0]);
    };
    const renderUpload = () => {
        if (form.values.thumbnailImage) {
            return (React.createElement(S.UploadOrImageContainer, null,
                React.createElement(RemovableUpload, { onRemove: () => {
                        form.setFieldValue(FormFields.thumbnailImage, '');
                    } },
                    React.createElement(UploadedImage, { image: form.values.thumbnailImage }))));
        }
        return (React.createElement(S.UploadOrImageContainer, null,
            React.createElement(Upload, { accept: {
                    'image/*': [],
                }, title: media.tablet ? (React.createElement("span", null,
                    "Drop image or ",
                    React.createElement("u", null, "browse"))) : ('Browse'), icon: UploadIcon, iconSize: 20, maxSize: 10485760, orientation: "vertical", onFileDrop: handleFileDrop, isUploading: isThumbnailImageUploading })));
    };
    return (React.createElement(Subsection, { title: "Thumbnail" },
        React.createElement(S.Container, null,
            renderUpload(),
            React.createElement(S.ImageInfo, null,
                "Primary visual for video series. Appears in the video catalog on the video series list section.",
                React.createElement(S.ImageInfoRecommendedSize, null, "Recommended size: 600 x 900 px")))));
};
